import { Scatter } from 'vue-chartjs'

export default {
  extends: Scatter,
  props: ['chartData', 'options'],
  methods: {
    rerender () {
      this._data._chart.destroy()
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    // Overwriting base render method with actual data.
    this.$watch(vm => [vm.chartData, vm.options].join(), this.rerender, { deep: true })
    this.renderChart(this.chartData, this.options)
  }
}
